import React from 'react'
import './index.css'

const BlogChip = ({ name, date }) => (
  <div className="detail-section">
    <div className="name">
      <span className="fw-medium dot">•</span>
      <span className="fw-medium">{name}</span>
    </div>
    <div className="date">
      <span className="fw-medium dot">•</span>
      <span className="fw-medium">{date}</span>
    </div>
  </div>
)

export default BlogChip